import { Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output, ViewChild } from '@angular/core';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';

@Component({
  selector: 'app-file-upload-custom',
  templateUrl: './file-upload-custom.component.html',
  styleUrls: ['./file-upload-custom.component.css']
})
export class FileUploadCustomComponent {

  @ViewChild('fileInput') fileInputRef!: ElementRef<HTMLInputElement>;
  selectedFiles: File[] = [];

  @Output() onFilesUpload = new EventEmitter<{files: File[], removeItem: boolean}>();

  @Input() fullWidth: boolean = false;

  onFilesDropped(files: any) {
    this.selectedFiles = [];
    this.addFiles(files);
    this.handleFiles();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.addFiles(input.files)
      input.value = ''; // Reset para permitir cargar el mismo archivo otra vez
      this.handleFiles();
    }
  }

  handleFiles() {
    this.onFilesUpload.emit({files :this.selectedFiles, removeItem: false});
  }

  addFiles(fileList: FileList) {
    const newFiles = Array.from(fileList);
    this.selectedFiles = this.selectedFiles.concat(newFiles);
  }

  removeFile(index: number) {
    this.selectedFiles.splice(index, 1);
    this.onFilesUpload.emit({files :this.selectedFiles, removeItem: true});
  }
}
